var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"w-100 container-fluid px-2"},[_c('router-view')],1),_c('footer',{staticClass:"w-100 mt-5 d-flex justify-content-center align-center"},[_c('p',{staticClass:"text-disabled"},[_vm._v(" © Trianon - "+_vm._s(new Date().getFullYear()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }